export default "__VITE_ASSET__DjCrsXPm__"